import Client from 'config/axios';

export const getAgents = async (token: string, limit: number, page: number) => {
  try {
    const { data } = await Client.get(`agent`, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    return { data: data.data };
  } catch (response) {
    const result = response as any;
    return { errors: result.data };
  }
};
